<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>用語統一チェック</h1>
                            <h2>誤解されない、
                                <br />精度の高い英文を</h2>
                            <p>Trinkaの用語統一チェック機能は、ボリュームの大きな文書であってもわずか数回のクリックで用語の不統一を検出し修正。文章の明瞭さや精度を格段に高められます。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/Consistency-Checks.png" alt="一貫性チェック - 英文チ ェッカー "/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/ConsistencyCheckThumbnail.png" alt="英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>用語統一チェックの使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>「用語統一チェック」が簡単に分かるチュートリアル動画をご覧ください。</p>
                            <p>ステップごとの解説で、機能を余すところなくお使いいただけます</p>
                            <p>疑問点については
                                <a style="color: #0000ff;" (click)="scroll(target)" class="text-link remove-left-space">FAQ</a>もあわせてお読みください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>用語統一チェックの主な機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>用語や表記の不統一を検出し、英文の精度を高めます。以下のようなタイプの用語・表記の不統一を修正します。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="feature_num">01</div>
                        <h3>スペル</h3>
                        <p>同じ単語の異なる綴り
                            <span class="yellow-bg">（アメリカ英語とイギリス英語など）</span>を識別します。
                        </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection" class="OpenSansFonts">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections" class="OpenSansFonts">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">02</div>
                        <h3>ハイフン、ダッシュ</h3>
                        <!-- <p class="fearureCardText">Trinka finds inconsistent use of
                            <span>hyphens and dashes</span> and makes them consistent with a click. </p> -->
                        <p>
                            <span  class="yellow-bg">ハイフンやダッシュ</span>の不統一を検出。ワンクリックでの統一が可能です。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet" class="OpenSansFonts">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet" class="OpenSansFonts">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">03</div>
                        <h3>数字の表記</h3>
                        <p>
                            <span class="yellow-bg">アラビア数字の表記とアルファベットでの表記</span>の混在などを検出。 ワンクリックで表記を統一できます。
                        </p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                    <label for="averagesixyears">
                                        <b class="OpenSansFonts">average six years</b>
                                        <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                        <b class="OpenSansFonts">average 6 years</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="average-sixyears" name="sadfdashesCehcks">
                                    <label for="average-sixyears">
                                        <b class="OpenSansFonts">average 6 years</b>
                                        <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                        <b class="OpenSansFonts">average six years</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">04</div>
                        <h3>記号・シンボル</h3>
                        <p>
                            <span class="yellow-bg">記号表記とアルファベット表記</span>の混在も検出します。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b class="OpenSansFonts">TNF-alpha"</b>
                                    <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                    <b class="OpenSansFonts">tnf-α"</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b class="OpenSansFonts">tnf-α"</b>
                                    <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                    <b class="OpenSansFonts">TNF-alpha"</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">05</div>
                        <h3>スペース</h3>
                        <p>手作業では見つけにくい単語間の
                            <span class="yellow-bg">スペース</span>の不統一も、Trinkaを使えば数回のクリックで文章全体で修正できます。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b class="OpenSansFonts">p
                                        <0</b>
                                            <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                            <b>p
                                                < 0</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b class="OpenSansFonts">p
                                        < 0</b>
                                            <img src="../../../assets/images/spacingArrow.png" alt="アイコン" />
                                            <b>p
                                                <0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">Trinkaで、正確で明瞭な英文を</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn" target="_blank">今すぐ始める</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            用語統一チェックとはどのようなものですか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse collapsed" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaの用語統一チェックでは、英文ライティングにありがちな用語・表記の不統一を自動的に検出しそれをすべてリスト化し、修正候補を表示します。言語やスタイルガイドを選択すれば、原稿全体をワンクリックで修正できます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            用語統一チェックの利用でポイント（Credit）は消費されますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ、用語統一チェックのご利用にポイントは必要ありません。何度でもご利用いただけます。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">用語統一チェックはどこで利用できますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>現在のところ用語統一チェックはTrinka Cloud上ですべてのユーザーの方がお使いいただけます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            用語統一チェックはどのような時に使えばよいですか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>原稿全体が完成した後に使用するのが理想ですが、必要であればいつでも、何度でもご利用いただけます。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/hTaMLLHICCo"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>